import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  Box,
  Grid,
  CircularProgress,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { homeService } from "services";
import { Field, reduxForm, getFormSyncErrors, getFormValues } from "redux-form";
import { renderTextField } from "components/FormFields/FieldTypes";

import { phone as phoneFormatter } from "components/FormFields/formatters";
import { phone as phoneNormalizer } from "components/FormFields/normalizers";
import { phone as phoneValidator } from "components/FormFields/validators";

const ShareApp = (props) => {
  const theme = useTheme();
  const { deviceInfo, authData, formValues, formErrors } = props;
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const [openShareApp, setOpenShareApp] = useState(false);
  const [isShareAppCancel, setIsShareAppCancel] = useState(false);
  const [showShareAppSuccess, setShareAppSuccess] = useState(null);
  const [loading, isLoading] = useState(false);
  const isWidgetEnabled = sessionStorage.getItem("widgetEnabled")?.toLowerCase() === "y";

  useEffect(() => {
    if (
      !window?.location?.pathname?.includes("/savings") &&
      !isShareAppCancel &&
      deviceInfo !== null &&
      deviceInfo?.shareAppFlag === "Y" &&
      !isWidgetEnabled
    ) {
      setOpenShareApp(true);
    }
  }, [deviceInfo]);

  const handleClose = () => {
    setOpenShareApp(false);
    setIsShareAppCancel(true);
    if (!showShareAppSuccess) {
      homeService.muteAppRating(deviceInfo?.shareAppEngagementId);
    }
  };

  const onFormSubmit = () => {
    isLoading(true);
    homeService
      .shareApp(formValues.phone, deviceInfo?.shareAppEngagementId)
      .then((res) => {
        setShareAppSuccess(res);
        isLoading(false);
        //call device endpoint to re-update the deviceInfo sessionStorage
        homeService.getDeviceDetails();
      }).catch((e) => {
        console.log(e);
        isLoading(false);
        setOpenShareApp(false);
        setIsShareAppCancel(true);          
      });
  };

  return (
    <>
      <Dialog
        //fullWidth={true}
        // maxWidth={"sm"}
        onClose={handleClose}
        open={openShareApp}
        className="app-dialog"
      >
        <DialogTitle sx={{ color: "#002060", textAlign: "center" }}>
          Help a Friend Get Cuverd!
        </DialogTitle>
        <DialogContent
          sx={{
            paddingLeft: matchesMinWidth ? "24px" : "40px",
            paddingRight: matchesMinWidth ? "24px" : "40px",
          }}
        >
          {loading && (
            <Box sx={{ textAlign: "center" }} mt={2}>
              <CircularProgress
                style={{ color: theme?.palette?.secondary?.main }}
              />
            </Box>
          )}
          {!showShareAppSuccess && !loading && (
            <>
              <Box mt={2}>
                <Grid sx={{ textAlign: "center" }} item xs={12}>
                  <Typography variant="h4LatoRegular" sx={{ color: "#607277" }}>
                    Enter the phone number to text the{" "}
                    {authData?.organization?.name} website:
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ paddingTop: "30px", paddingBottom: "30px" }}
                >
                  <Field
                    name="phone"
                    isRequired
                    component={renderTextField}
                    label="Mobile phone number"
                    format={phoneFormatter}
                    validate={[phoneValidator]}
                    normalize={phoneNormalizer}
                  />
                </Grid>
                <Grid sx={{ textAlign: "center" }} item xs={12}>
                  <Typography variant="h4LatoBold" sx={{ fontSize: "12px" }}>
                    By continuing to use this website, you agree to the Cuverd{" "}
                    <Box
                      component={Link}
                      to="/terms-and-conditions"
                      sx={
                        {
                          //textDecoration: "none",
                        }
                      }
                    >
                      <Typography
                        component={"span"}
                        sx={{ color: "#4fa95f", fontSize: "12px" }}
                        variant="h3LatoBold"
                      >
                        Terms and Conditions
                      </Typography>
                    </Box>{" "}
                    and{" "}
                    <Box
                      component={Link}
                      to="/privacy-policy"
                      sx={
                        {
                          //textDecoration: "none",
                        }
                      }
                    >
                      <Typography
                        component={"span"}
                        sx={{ color: "#4fa95f", fontSize: "12px" }}
                        variant="h3LatoBold"
                      >
                        Privacy Policy
                      </Typography>
                    </Box>{" "}
                  </Typography>
                </Grid>
              </Box>
              <Box sx={{ textAlign: "center" }} mt={3} mb={1}>
                <Button
                  onClick={() => onFormSubmit()}
                  disabled={
                    !formValues || Object.keys(formErrors).length ? true : false
                  }
                  sx={{
                    width: 200,
                    backgroundColor:
                      !formValues || Object.keys(formErrors).length
                        ? "#e6e6e6"
                        : "#83d712",
                  }}
                  variant="filled"
                >
                  SHARE THE SAVINGS
                </Button>
              </Box>
            </>
          )}

          {showShareAppSuccess && !loading && (
            <Grid sx={{ textAlign: "center" }} item xs={12}>
              <Typography variant="h4LatoRegular" sx={{ color: "#607277" }}>
                {showShareAppSuccess.message}
              </Typography>
            </Grid>
          )}
          {!loading && (
            <Box sx={{ textAlign: "center" }} mt={3} mb={1}>
              <Button
                sx={{ minWidth: 200 }}
                onClick={() => {
                  handleClose();
                }}
              >
                {showShareAppSuccess ? "OK" : "CANCEL"}
              </Button>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("SHARE_APP_FORM")(state) || {},
    formValues: getFormValues("SHARE_APP_FORM")(state),
    organizationInfo: state.organizationInfo.data,
    authData: state.authentication.authData,
    deviceInfo: JSON.parse(sessionStorage.getItem("deviceInfo")),
    // organizationInfo: { suffix: "WGN" },
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "SHARE_APP_FORM",
  })(ShareApp)
);
